import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";

// Helper function to get the nearest section's background color
const getSectionBackgroundColor = () => {
  const elementBehindHeader = document.elementFromPoint(
    window.innerWidth / 2,
    75 // Adjust based on header height
  );

  if (elementBehindHeader) {
    let currentElement = elementBehindHeader;
    // Traverse up to find the closest section with a solid background
    while (currentElement && currentElement !== document.body) {
      const bgColor = window.getComputedStyle(currentElement).backgroundColor;
      if (
        bgColor &&
        bgColor !== "rgba(0, 0, 0, 0)" &&
        bgColor !== "transparent"
      ) {
        return bgColor;
      }
      currentElement = currentElement.parentElement;
    }
  }

  return "rgb(0, 0, 0)"; // Default to white if no valid background color is found
};

const Logo = ({ LogoSvg, height = "100%" }) => {
  const [logoColor, setLogoColor] = useState("black");

  // Function to update logo color based on background color
  const updateLogoColor = () => {
    const bgColor = getSectionBackgroundColor();

    const [r, g, b] = bgColor.match(/\d+/g).map(Number); // Extract RGB values
    const brightness = (r * 299 + g * 587 + b * 114) / 1000; // Luminance formula

    // Update the logo color based on brightness
    setLogoColor(brightness < 128 ? "white" : "black");
  };

  useEffect(() => {
    // Scroll event listener optimized with requestAnimationFrame
    const handleScroll = () => {
      requestAnimationFrame(updateLogoColor);
    };

    window.addEventListener("scroll", handleScroll);

    // Initial check on mount
    updateLogoColor();

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Box
      sx={{
        margin: "0.5rem",
        width: "auto",
        height: "auto",
        overflow: "hidden",
        color: logoColor, // Apply the detected color
      }}
    >
      <LogoSvg height={height} fill={logoColor} />
    </Box>
  );
};

export default Logo;
